import React, { useContext } from "react";

/// React router dom
import { Routes, Route, Outlet, useLocation ,useNavigate} from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
import { useSelector } from "react-redux";
/// Dashboard
import Home from "./components/Dashboard/Home";
import DashboardDark from "./components/Dashboard/DashboardDark";
import Project from "./components/Dashboard/Project";
import Contacts from "./components/Dashboard/Contacts";
import Kanban from "./components/Dashboard/Kanban";
import Task from "./components/Dashboard/Task";
import DashboardCalendar from "./components/Dashboard/DashboardCalendar";
import Messages from "./components/Dashboard/Messages";

///Demo
import Theme1 from "./components/Dashboard/Demo/Theme1";
import Theme2 from "./components/Dashboard/Demo/Theme2";
import Theme3 from "./components/Dashboard/Demo/Theme3";
import Theme4 from "./components/Dashboard/Demo/Theme4";
import Theme5 from "./components/Dashboard/Demo/Theme5";
import Theme6 from "./components/Dashboard/Demo/Theme6";

//Content
import Content from "./components/Cms/Content";
import Menu from "./components/Cms/Menu";
import EmailTemplate from "./components/Cms/EmailTemplate";
import Blog from "./components/Cms/Blog";
//CMS Linking Pages
import ContentAdd from "./components/Cms/ContentAdd";
import AddMail from "./components/Cms/AddMail";
import AddBlog from "./components/Cms/AddBlog";
import BlogCategory from "./components/Cms/BlogCategory";

/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import EditProfile from "./components/AppsMenu/AppProfile/EditProfile";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
// import Chartist from "./components/charts/chartist";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import Nestable from "./components/PluginsMenu/Nestable/Nestable";
import MainNouiSlider from "./components/PluginsMenu/NouiSlider/MainNouiSlider";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";

//Redux
import Todo from "./pages/Todo";

/// Widget
import Widget from "./pages/Widget";

/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import DataTable from "./components/table/DataTable";
import BootstrapTable from "./components/table/BootstrapTable";

/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages

import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import Setting from "./layouts/Setting";
import { ThemeContext } from "../context/ThemeContext";
import { AuthContext } from "../context/AuthContext";
import { adminRoutes, allAdminroutes } from "../routes/AdminRoutes";
import { allUserroutes } from "../routes/UserRoutes";
import { allVenueManagerroutes } from "../routes/VenueManager";
import { useCheckRoute } from "../utils/invalidRoute";
import ForceLogout from "../admin/admincomponent/forceLogout/ForceLogout";
import { useMenuManagement } from "../context/MenuManagementContext";
const Markup = () => {
  
  const internalRoutes = [
    "registration",
    "verification-form/:id",
    "verification-Individual-form/:id",
    "organization-verification/:id",
    "verification-view-form/:id",
    "verification-insitute-view-form/:id",
    "edit-profile-request-view/:id",
    "account/account-profile/:id",
    "account/role/update/:id",
    "account/role-assign/:id",
    "booking-details/:id",
    "ticket-details/:id",
    "payment-summary",
    "manager-ticket-details"
  ];
  const userType = localStorage.getItem("user_type");
  const { loading, menuDataList, fetchMenuList, setMenuId, menuId } = useMenuManagement();
  const { user, USER_LEVEL } = useContext(AuthContext);
  const loginDetails = JSON.parse(localStorage.getItem("login_Details"));
  const userId = loginDetails?.user?.id;

  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  const Navigate = useNavigate();

   const permissionRoutes =
    JSON.parse(localStorage.getItem("permission_route_url")) || [];

      let routeType = [];

  // let pagePath = path.split("-").includes("page");
  // let routeType = [];
   if (user?.role === "admin") {
    if (user?.user_level == USER_LEVEL.ADMIN) {
      routeType = allAdminroutes;
    }
    if (
      user?.user_level == USER_LEVEL.SUB_ADMIN ||
      user?.user_level == USER_LEVEL.ADMIN_CHECKER ||
      user?.user_level == "4"
    ) {
      const allExternal = permissionRoutes.every((route) =>
        /^https?:\/\//i.test(route)
      );

      const currentRoute = window.location.pathname.replace(/^\/+/, "");

      const routeExistsInAdmin = allAdminroutes.some(
        (route) => route.url === currentRoute
      );

      // if (routeExistsInAdmin && !permissionRoutes.includes(currentRoute)) {
      //   // redirect to profile page
      //    Navigate(`/account/account-profile/${userId}`, { replace: true });

      //   routeType = allAdminroutes.filter(
      //     (route) => route.url === "account/account-profile/:id"
      //   );
      // }
      const isInternalRoute = internalRoutes.some((route) => {
        const regex = new RegExp(
          "^" + route.replace(":id", "[^/]+") + "$"
        );
        return regex.test(currentRoute);
      });

      if (
        routeExistsInAdmin &&
        !permissionRoutes.includes(currentRoute) &&
        !isInternalRoute
      ) {
        // redirect to profile page
        Navigate(`/account/account-profile/${userId}`, { replace: true });

        routeType = allAdminroutes.filter(
          (route) => route.url === "account/account-profile/:id"
        );
      }

      else if (allExternal) {
        routeType = allAdminroutes.filter(
          (route) => route.url === "account/account-profile/:id"
        );
      }
      else {
        routeType = allAdminroutes.filter((route) =>
          permissionRoutes.includes(route.url) || internalRoutes.includes(route.url)
        );
      }
    }
  }

  return (
     <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route path="/force-logout" element={<ForceLogout />} />
        <Route path="no-permission" element={<LockScreen />} />

        {/* <Route path="*" element={<Error404 />} /> */}
        {/* ✅ Add your route here */}

        {/* <Route path="profile" element={<ProfileComp />} /> */}
        {/* {useCheckRoute() && <Route path="*" element={<Error404 />} />} */}

        <Route element={<MainLayout />}>
         
          {routeType?.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}


          {userType === "user" &&
            allUserroutes?.map((data, i) => (
              <Route
                key={i}
                exact
                path={`${data.url}`}
                element={data.component}
              />
            ))}

          {user?.role === "admin" &&
            user?.user_level == USER_LEVEL.VENUE_MANAGER &&
            allVenueManagerroutes?.map((data, i) => (
              <Route
                key={i}
                exact
                path={`${data.url}`}
                element={data.component}
              />
            ))}
          {/* {routeType?.length > 0 && (
            <Route path="*" element={<Error404 />} />
          )} */}
        </Route>
      </Routes>
      <Setting />
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  const isSidebarOpen = useSelector((state) => state.ui.isSidebarOpen);
  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${menuToggle ? "menu-toggle" : ""
        }`}
    >
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className={`${isSidebarOpen ? "container-fluid" : "container-fluid-collapse"}`}>
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Markup;
